import classNames from 'classnames';
import moment from 'moment';
import React, { Fragment } from 'react';
import { statusConverterForWhiteBackground } from 'utils/statusConverter';


const columnData = (statusCode, flag, moduleList) => {
  
  return {
    logIdx: {
      colWidth: '50px',
      th: <th rowSpan={5}>No.</th>,
      td: (props) => {
        return <td>{props.index + 1}</td>;
      },
    },
    areaNo: {
      colWidth: '200px',
      th: <th rowSpan={4}>도크</th>,
      td: (props) => {
        const areaNos = moduleList?.find((x) => x.modelNo === props.modelNo).areaNo
        return <></>;
      },
    },
    areaNm: {
      colWidth: '200px',
      th: <th rowSpan={4}>위치</th>,
      td: (props) => {
        const areaNms = moduleList?.find((x) => x.modelNo === props.modelNo).areaNm
        return <td colSpan={4}>{areaNms || '-'}</td>;
      },
    },
    shipNo: {
      colWidth: '150px',
      th: <th rowSpan={4}>호선</th>,
      td: (props) => {
        const shipNos = moduleList?.find((x) => x.modelNo === props.modelNo).shipNo
        return <></>;
      },
    },
    locationNm: {
      colWidth: '400px',
      th: <th rowSpan={4}>장소</th>,
      td: (props) => {
        const locationNms = moduleList?.find((x) => x.modelNo === props.modelNo).locationNm
        return <></>;
      },
    },
    userDt: {
      colWidth: '200px',
      th: <th rowSpan={5}>건조부</th>,
      td: (props) => {
        const userDts = moduleList?.find((x) => x.modelNo === props.modelNo).userDt
        return <td>{userDts || '-'}</td>;
      },
    },
    userSt: {
      colWidth: '200px',
      th: <th rowSpan={5}>안전부</th>,
      td: (props) => {
        const userSts = moduleList?.find((x) => x.modelNo === props.modelNo).userSt
        return <td>{userSts || '-'}</td>;
      },
    },
    userSc: {
      colWidth: '200px',
      th: <th rowSpan={5}>선커부</th>,
      td: (props) => {
        const userScs = moduleList?.find((x) => x.modelNo === props.modelNo).userSc
        return <td>{userScs || '-'}</td>;
      },
    },
    o2: {
      colWidth: '100px',
      th: (
          <th rowSpan={2} className='vertical-align-middle'>
            산소 <br /> O<sub>2</sub>(%)
          </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? <td className={classNames('data-text', props.o2_status)}>{props.o2?.toFixed(1)}</td> : <td colSpan={props.gasCnt}>REPEATER</td>)
      },
    },
    h2s: {
      colWidth: '100px',
      th: (
        <th rowSpan={2}>
          황화수소 <br /> H<sub>2</sub>S(ppm)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? <td className={classNames('data-text', props.h2s_status)}>{props.h2s}</td> : <td>-</td> : <></>)
      },
    },
    co: {
      colWidth: '100px',
      th: (
        <th rowSpan={2}>
          일산화탄소 <br /> CO(ppm)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? <td className={classNames('data-text', props.co_status)}>{props.co}</td> : <td>-</td> : <></>)
      },
    },
    hc: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          {flag === "0" ? <>폭발성가스 <br /> CH4(%LEL)</> : <>탄화수소 <br /> HC(%)</>}
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? <td className={classNames('data-text', props.hc_status)}>{props.hc}</td> : <td>-</td> : <></>)
      },
    },
    co2: {
      colWidth: '120px',
      th: (
        <th rowSpan={2}>
          이산화탄소 <br /> CO<sub>2</sub>(%)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? <td className={classNames('data-text', props.co2_status)}>{props.co2?.toFixed(1)}</td> : <></>)
      },
    },
    methanol: {
      colWidth: '120px',
      th: (
        <th rowSpan={3}>
          메탄올 <br /> CH<sub>3</sub>OH(PPM)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? <td className={classNames(`data-text`, props.methanol_status)}>{props.methanol}</td> : <></>)
      },
    },
    nh3: {
      colWidth: '120px',
      th: (
        <th rowSpan={3}>
          암모니아 <br /> NH<sub>3</sub>(PPM)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? <td className={classNames(`data-text`, props?.nh3_status)}>{props?.nh3}</td> : <></>)
      },
    },
    modelNo: {
      colWidth: '250px',
      th: <th rowSpan={5}>감지기</th>,
      td: (props) => {
        return <td>{props.modelNm}</td>;
      },
    },
    status: {
      colWidth: '130px',
      th: <th rowSpan={5}>상태</th>,
      td: (props) => {
        return (statusCode === '0' ? <td>{statusConverterForWhiteBackground(props.status)}</td> : <></>)
      },
    },
    battery: {
      colWidth: '130px',
      th: <th rowSpan={5}>배터리</th>,
      td: (props) => {
        return <td>{Math.floor(props.battery)} %</td>;
      },
    },
    rgstDt: {
      colWidth: '400px',
      th: <th rowSpan={5}>측정시간</th>,
      td: (props) => {
        return <td>{props.rgstDt && moment(props.rgstDt).format('YYYY-MM-DD HH:mm:ss')}</td>;
      },
    },
  };
}

export default columnData;
